import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { FactoryService } from '../core/services/factory/factory.service';
import { HttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class BilhetadoraService {
  constructor(private httpService: HttpService, private factory: FactoryService) {}
  public async getBilhetadoras(params?) {
    const url = '/Bilhetadora?Ativo=true';
    const options = await this.factory.defaultHttpHeaders(params);
    return await this.httpService.get(url, options);
  }

  public async getBilhetadoraPorId(id: number, params?) {
    const url = '/Bilhetadora/' + id;
    const options = await this.factory.defaultHttpHeaders(params);
    return await this.httpService.get(url, options);
  }
  public async putBilhetadora(request) {
    const url = `/Bilhetadora`;
    const options = await this.factory.defaultHttpHeaders();
    return await this.httpService.put(url, request, options);
  }

  public async deleteBilhetadora(id) {
    const url = `/Bilhetadora/${id}`;
    const options = await this.factory.defaultHttpHeaders();
    return await this.httpService.delete(url, options);
  }

  public handleError(error: any) {
    console.error(error);
    return throwError(error);
  }
}
